"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const use_pusher_1 = require("@harelpls/use-pusher");
const StatusBarComponent = (props) => {
    const { members = {} } = (0, use_pusher_1.usePresenceChannel)(props.channelName);
    return (react_1.default.createElement("div", null, Object.keys(members).length ? (react_1.default.createElement("div", null,
        "Redakteure\u00A0(",
        Object.keys(members).length,
        "):\u00A0",
        Object.entries(members)
            .map(([id, member], index) => (react_1.default.createElement("span", { key: id },
            index > 0 ? ', ' : '',
            member.name))))) : null));
};
exports.default = StatusBarComponent;
